import {shallowRef, ref, useId} from 'vue';
// @ts-expect-error No declaration file found for module 'swiper'.
import type {Swiper as SwiperClass} from 'swiper';

export function useSwiperNavigation() {
    const swiperRef = shallowRef<SwiperClass>();
    const isNavigationHidden = ref(false);

    function setUniqueSelectors() {
        const instanceId = useId().replace(/:/g, '');
        const navigationPrevClass = `testimonials-carousel-nav-prev--${instanceId}`;
        const navigationNextClass = `testimonials-carousel-nav-next--${instanceId}`;

        return {
            navigationPrevClass,
            navigationNextClass,
        };
    }

    function onSwiper(swiper: SwiperClass) {
        swiperRef.value = swiper;
        computeIsNavigationHidden();
    }

    function onResize(swiper: SwiperClass) {
        swiperRef.value = swiper;
        computeIsNavigationHidden();
    }

    function computeIsNavigationHidden() {
        isNavigationHidden.value = !!swiperRef.value && swiperRef.value.isBeginning && swiperRef.value.isEnd;
    }

    return {
        onSwiper,
        onResize,
        setUniqueSelectors,
        isNavigationHidden,
    };
}

/**
 * Ensure unique selectors per instance to be able to use multiple carousels on the same page.
 */
export function useUniqueSelectors(variantName: string) {
    const instanceId = useId().replace(/:/g, '');
    const navigationPrevClass = `testimonials-${variantName}-nav-prev--${instanceId}`;
    const navigationNextClass = `testimonials-${variantName}-nav-next--${instanceId}`;
    const paginationClass = `testimonials-${variantName}-pagination--${instanceId}`;

    return {
        navigationPrevClass,
        navigationNextClass,
        paginationClass,
    };
}
